import { getInit } from "./InitGradeSelector";
import GradeSelector from "./components/toyota/GradeSelector";

// Webpack entry point for Apheleia Grade Selector Toyota AEM
export const init = getInit(GradeSelector);
